import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { TokenService } from '../services/token.service';

@Injectable()
export class SuperAdminGuard implements CanActivate {

  constructor(
    public tokenService: TokenService, 
    public router: Router
  ) {}

  canActivate(): boolean {

    const roles: string[] = this.tokenService.getRoles();
    
    if(!this.tokenService.isValid() || !roles.includes('superadmin')) {
      this.router.navigateByUrl('/');
      return false;    
    }   

    return true;
  }
}
